export const ALL_CLIENT_ORDERS = 'ALL_CLIENT_ORDERS'
export const ALL_ORGANIZATION_ORDERS = 'ALL_ORGANIZATION_ORDERS'
export const GET_QUERY_IN_ORDER_FORMAT = 'GET_QUERY_IN_ORDER_FORMAT'

export const CLEAR_ORDER_REDUCER = 'CLEAR_ORDER_REDUCER'